<template>
    <div>
        <template v-if="allowToAddExplanationRequest">
            <b-button variant="custom-green" class="text-uppercase" @click="onAddRequestClick">Добавить запрос</b-button>
            <b-form-text class="desc-text mb-2 mt-0"> Доступна отправка не более двух запросов от организации до подачи предложения </b-form-text>
        </template>
        <b-table :fields="fields" :items="explanationRequests" table-class="table-atmo" show-empty empty-text="Запросы отсутствуют">
            <template #cell(request)="row">
                <div :class="row.item.is_my_request ? 'text-danger' : ''">
                    {{ row.item.request }}
                </div>
                <a v-if="row.item.request_document" :href="$getAttachmentDownloadLink(row.item.request_document.id)" class="atmo-button-link">{{ row.item.request_document.name }}</a>
            </template>
            <template #cell(answer)="row">
                <div>
                    {{ row.item.answer ?? '—' }}
                </div>
                <a v-if="row.item.answer_document" :href="$getAttachmentDownloadLink(row.item.answer_document.id)" class="atmo-button-link">{{ row.item.answer_document.name }}</a>
            </template>
            <template #cell(actions)="row">
                <b-button v-if="row.item.allow_to_add_answer" variant="custom-green-small" class="text-uppercase bg-secondary" @click="onAnswerClick(row.item.id)">Ответить</b-button>
            </template>
        </b-table>
        <ExplanationRequestAddModal :show-modal="showModal" :is-request="isRequest" @done="onDone" @close="showModal = false" :request-id="requestId" :purchase-type="purchaseType" />
    </div>
</template>

<script>
import ExplanationRequestAddModal from '@/components/purchases/ExplanationRequests/explanation-request-add-modal.vue';

export default {
    name: 'ExplanationRequestList',
    components: { ExplanationRequestAddModal },
    props: {
        purchaseItem: {
            required: true,
            type: Object
        },
        purchaseType: {
            type: String,
            default: 'fl44'
        }
    },
    data() {
        return {
            fields: [
                { key: 'request', label: 'Запрос', tdClass: 'text-block' },
                { key: 'answer', label: 'Ответ', tdClass: 'text-block' },
                { key: 'actions', label: '', tdClass: 'text-right btn-width' }
            ],
            explanationRequests: [],
            allowToAddExplanationRequest: false,
            currentDate: null,
            showModal: false,
            requestId: null,
            isRequest: true
        };
    },
    async mounted() {
        await this.fillData();
    },
    methods: {
        onAddRequestClick() {
            this.isRequest = true;
            this.showModal = true;
        },
        onDone(data) {
            this.allowToAddExplanationRequest = data.allow_to_add_explanation_request;
            this.explanationRequests = data.explanation_requests;
            this.showModal = false;
        },
        async fillData() {
            await this.$api.products[this.purchaseType].purchases.getExplanationRequests(this.purchaseItem.id)
                .then((response) => {
                    this.allowToAddExplanationRequest = response.data.allow_to_add_explanation_request;
                    this.explanationRequests = response.data.explanation_requests;
                });
        },
        onAnswerClick(requestId) {
            this.requestId = requestId;
            this.isRequest = false;
            this.showModal = true;
        }
    }
};
</script>

<style>
.btn-width {
    width: 1% !important;
}
.text-block {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    text-indent: -4px;
    width: 50%;
}
</style>

<style scoped>
.desc-text {
    color: var(--danger) !important;
}
</style>
